<template>
  <div class="default-empty-data" :style="`height:${custom.height};`">
    <div class="content">
      <img class="img" :src="custom.img || require('@/assets/images/emptyDefault/emptyCard.png')" alt="" />
      <h3 v-if="custom.title">{{ custom.title }}</h3>
      <span v-if="!custom.slotText">{{ custom.text || $t('system::common::btn::no_data') }}</span>
      <slot name="text"></slot>
      <span style="margin-top: 10px" v-if="custom.desc">{{ custom.desc }}</span>
      <div class="btn-style" v-if="custom.buttons && custom.buttons.length > 0">
        <template v-for="(item, index) in custom.buttons">
          <el-button :type="item.type ? item.type : 'primary'" @click="item.btnClick" :key="index" v-if="!item.auth || authPromise(item.auth)">
            {{ item.text }}
          </el-button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'default-data',
  props: {
    custom: {
      default: () => {
        return {
          height: '490px',
          img: '',
          title: '',
          text: '',
          buttons: []
        }
      }
    }
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.default-empty-data {
  border-radius: 12px;
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .img {
      // margin-bottom: 16px;
      width: 116px;
    }
    h3 {
      margin-top: 5px;
    }
    span {
      color: $--text-99;
      font-size: 14px;
      line-height: 1;
    }
  }
}
</style>
